module.exports = __webpack_public_path__ + "img/persona2.f81d326d.jpg";